import { render } from "./PersonalFundraisingShareOverlay.vue?vue&type=template&id=b077c080"
import script from "./PersonalFundraisingShareOverlay.vue?vue&type=script&lang=js"
export * from "./PersonalFundraisingShareOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__